export default __webpack_public_path__ + "static/media/13.d68aa0f3.jpg";